import { loginRequest } from '../../api/user';
import { encrypt } from '../../utils/crypto'

export default {
  namespaced: true,
  state: {
    token: '',
    expired: 0,
    profile: 0,
    isLogunned: false
  },

  getters: {
    token: state => state.token,
    expired: state => state.expired,
    isLogunned: state => state.isLogunned,
    profile: state => state.profile
  },

  actions: {
    async login({ commit }, payload) {
      try {
        const { status, data } = await loginRequest(payload);
        const { token, exp, profile,permission } = data;
        
        if (status == 200) {
          if (token && profile) {
            const encryptedProfile = encrypt(JSON.stringify(profile));
            const encryptedPermission = encrypt(JSON.stringify(permission));
            localStorage.setItem('setProfile',encryptedProfile);
            localStorage.setItem('setPrm',encryptedPermission);
            localStorage.setItem('token', token)
            commit("set_token", token);
            commit("set_expired", exp);
            commit("set_isLogunned", true);
            commit("set_profile", profile)
          }
        } else {
          console.log('Error en el login:', status);
          commit("set_isLogunned", false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },

  mutations: {
    set_token(state, token) {
      state.token = token
    },

    set_expired(state, exp) {
      state.expired = exp
    },

    set_isLogunned(state, isLogunned){
      state.isLogunned = isLogunned;
    },

    set_profile(state, profile) {
      state.profile = profile;
    }
  }
}

